// scheme链接前缀
const SCHEME_MACHPRO_WITH_PRE = 'sailorc://keeta.com/machpro'
// mach_bundle_name前缀
const MACHPRO_BUNDLE_NAME_PRE = 'mach_pro_sailor_mkt_member_'
// 会员项目bundle_name
const MEMBER_BUNDLE = {
  MAIN: 'main', // 主页
  ORDER_SUBMIT: 'orderSubmit', // 提单页
  MANAGE: 'manage', // 会籍管理
  CALCULATOR: 'calculator', // 省钱计算器
  BILL: 'bill', // 开通明细
}

// 订单类型
enum OrderType {
  TakeawayOrder = 0, // 外卖下单
  BuyMember = 1, // 购买会员
}
// 提单页标识
enum PreviewFlag {
  Input = 0, // 进入提单页
  Reload = 1, // 提单页更新
}
// 会员状态
enum UserMemberStatus {
  In = 1, // 在籍：生效中
  Unsubscribe = 2, // 在籍但已退订
  Exile = 3, // 脱籍：已过期
}

// 会员卡类型
enum MemberCardType {
  Month = 1, // 月卡
  Quarter = 2, // 季卡
  Year = 3, // 年卡
  Free = 4, // 试用卡
}

export { SCHEME_MACHPRO_WITH_PRE, MACHPRO_BUNDLE_NAME_PRE, MEMBER_BUNDLE, OrderType, PreviewFlag, UserMemberStatus, MemberCardType }
